/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.PayInOutReasons {
    angular.module("meevo.plugins.payinoutreasons", []);
}